import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { colors, radii } from '@gbs-monorepo-packages/styles';

import { BaseAccordionContent, BaseAccordionTrigger } from '../BaseAccordion';
import { BaseSlot } from '../BaseSlot';

interface ISidebarItemsProps {
  $isShrunken?: boolean;
}

export const SidebarMultipleContent = styled.div<ISidebarItemsProps>`
  display: flex;
  ${({ $isShrunken = false }) =>
    $isShrunken &&
    css`
      &:hover {
        filter: brightness(0.9);
      }
    `}
`;

const sidebarItems = css<ISidebarItemsProps>`
  align-items: center;
  color: ${colors.sidebarTextLight};
  display: flex;
  flex-direction: row;
  justify-content: ${({ $isShrunken = false }) =>
    $isShrunken ? 'center' : 'flex-start'};
  padding: 0.5rem 0.3125rem;
  position: relative;
  text-decoration: none;
  width: 100%;
  background-color: ${colors.sidebarBackground};

  @media screen and (max-width: 600px) {
    /* is a reverse logic of isShrunken */
    justify-content: ${({ $isShrunken = false }) =>
      !$isShrunken ? 'center' : 'flex-start'};
  }
`;

const activeNavLinkStyled = css`
  color: ${colors.sidebarText};
  background-color: ${colors.sidebarBackgroundActive};

  &::after {
    background-color: ${colors.blue300};
    border-bottom-right-radius: ${radii.md};
    border-top-right-radius: ${radii.md};
    content: '';
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 0.25rem;
  }
`;

const leftPartButtonItemStyle = css<ISidebarItemsProps>`
  ${sidebarItems}
  border: none;
  flex-grow: 1;
  padding: 1rem
    ${({ $isShrunken = false }) => ($isShrunken ? '0.75rem' : '1.875rem')} !important;
  ${({ $isShrunken = false }) =>
    !$isShrunken &&
    css`
      padding-right: 0rem !important;
    `}
  width: unset;

  :hover {
    filter: brightness(0.9);
  }

  @media screen and (max-width: 600px) {
    /* is a reverse logic of isShrunken */
    padding: 1rem
      ${({ $isShrunken = false }) =>
        !$isShrunken ? '0.75rem' : '0 1rem 1.875rem'} !important;
  }
`;

export const LeftPartButtonItem = styled.button<ISidebarItemsProps>`
  ${leftPartButtonItemStyle}
`;

// prettier-ignore
export const RightPartExpandButton = styled(BaseAccordionTrigger)<ISidebarItemsProps>`
  ${sidebarItems}
  border: none;
  height: 100%;
  padding: 1rem
    ${({ $isShrunken = false }) => ($isShrunken ? '0.75rem' : '1.875rem')};
  padding-left: 0rem;
  width: unset;

  :hover {
    filter: brightness(0.9);
  }

  @media screen and (max-width: 600px) {
    /* is a reverse logic of isShrunken */
    padding: 1rem
      ${({ $isShrunken = false }) => (!$isShrunken ? '1.875rem 1rem 0' : '1.875rem')};
  }

  ${({ $isShrunken = false }) =>
    $isShrunken &&
    css`
      position: absolute;
      height: 3.5rem;
      background-color: transparent;
      width: 100%;
      left: 0;
    `}
`;

export const ExpandButton = styled(BaseAccordionTrigger)<ISidebarItemsProps>`
  ${sidebarItems}
  border: none;
  padding: 1rem
    ${({ $isShrunken = false }) => ($isShrunken ? '0.75rem' : '1.875rem')};

  :hover {
    filter: brightness(0.9);
  }

  @media screen and (max-width: 600px) {
    /* is a reverse logic of isShrunken */
    padding: 1rem
      ${({ $isShrunken = false }) => (!$isShrunken ? '0.75rem' : '1.875rem')};
  }
`;

export const NavLinkCustom = styled(NavLink)`
  text-decoration: none;

  &.active ${ExpandButton} {
    ${activeNavLinkStyled}
  }
`;

// prettier-ignore
export const ExpandButtonContent = styled(BaseAccordionContent)<ISidebarItemsProps>`
  ${({ $isShrunken = false }) =>
    $isShrunken &&
    css`
      display: none;
    `};
`;

export const ButtonItem = styled.button<ISidebarItemsProps>`
  ${sidebarItems}
  border: none;
  padding: 1rem
    ${({ $isShrunken = false }) => ($isShrunken ? '0.75rem' : '1.875rem')};

  :hover {
    filter: brightness(0.9);
  }

  @media screen and (max-width: 600px) {
    /* is a reverse logic of isShrunken */
    padding: 1rem
      ${({ $isShrunken = false }) => (!$isShrunken ? '0.75rem' : '1.875rem')};
  }
`;

export const LinkItem = styled(NavLink)<ISidebarItemsProps>`
  ${sidebarItems}
  color: ${colors.sidebarTextLight};
  padding: 0.875rem
    ${({ $isShrunken = false }) => ($isShrunken ? '0.75rem' : '1.875rem')};

  :hover {
    filter: brightness(0.9);
  }

  &.active {
    ${activeNavLinkStyled}
  }

  @media screen and (max-width: 600px) {
    /* is a reverse logic of isShrunken */

    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.875rem
      ${({ $isShrunken = false }) => (!$isShrunken ? '0.75rem' : '0.875rem')};
  }
`;

interface ITextProps {
  $isShrunken?: boolean;
}

export const sidebarTextStyle = css<ITextProps>`
  font-size: 1rem;
  font-weight: 400;
  text-align: left;
`;

export const Text = styled.p<ITextProps>`
  ${sidebarTextStyle}
  flex-grow: 1;
  margin-left: 1rem;
  padding-right: 1rem;

  ${({ $isShrunken = false }) =>
    $isShrunken &&
    css`
      display: none;
    `}
  @media screen and (max-width: 600px) {
    /* is a reverse logic of isShrunken */
    display: block;

    ${({ $isShrunken = false }) =>
      !$isShrunken &&
      css`
        display: none;
      `}
  }
`;

export const LeftPartButtonItemSlot = styled(BaseSlot)<ISidebarItemsProps>`
  ${leftPartButtonItemStyle}
  ${sidebarTextStyle}
  cursor: pointer;
  flex-grow: 1;
  width: 100%;
`;
